import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Labels } from 'src/app/shared/labels';

export const generatePdfFromComponent = async function (
  results: any,
  prfNumber: string,
  prfName: string,
  currentYear: number,
  options?: { filename?: string; scale?: number }
) {
  function renderCompanyInfo(companyInfo: any): string {
    if (!companyInfo) return '<em>No Data</em>';
    return `
    <div class="form-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 24px; font-size: 13px; padding: 0 32px;">
      <div>
        <div class="form-label" style="font-weight:600;">Company Name</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.compname || ''
        }</div>
        <div class="form-label" style="font-weight:600;">Email Address</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.reportofficer || ''
        }</div>
        <div class="form-label" style="font-weight:600;">Title</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.title || ''
        }</div>
        <div class="form-label" style="font-weight:600;">Address</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.address || ''
        }</div>
        <div class="form-label" style="font-weight:600;">City</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.city || ''
        }</div>
        <div class="form-label" style="font-weight:600;">Zip Code</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.zipcode || ''
        }</div>
        <div class="form-label" style="font-weight:600;">Allow Group Reporting?</div>
        <div class="radio-group form-value" style="margin-bottom:8px;">
          <input type="radio" ${
            companyInfo.groupreport === 'on' ? 'checked' : ''
          } disabled> Yes
          <input type="radio" ${
            companyInfo.groupreport !== 'on' ? 'checked' : ''
          } disabled> No
        </div>
        <div class="form-row-adjacent" style="display: flex; gap: 16px;">
          <div>
            <div class="form-label" style="font-weight:600;">NAIC Code</div>
            <div class="form-value" style="margin-bottom:8px;">${
              companyInfo.naic || '—'
            }</div>
          </div>
          <div>
            <div class="form-label" style="font-weight:600;">AM Best</div>
            <div class="form-value" style="margin-bottom:8px;">${
              companyInfo.ambest || '—'
            }</div>
          </div>
        </div>
      </div>
      <div>
        <div class="form-label" style="font-weight:600;">Preparer's Name</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.preparer || ''
        }</div>
        <div class="form-label" style="font-weight:600;">Additional Email Address</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.additionalemail || '—'
        }</div>
        <div class="form-label" style="font-weight:600;">State</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.state || ''
        }</div>
        <div class="form-label" style="font-weight:600;">Phone Number</div>
        <div class="form-value" style="margin-bottom:8px;">${
          companyInfo.phone || ''
        }</div>
      </div>
    </div>
    `;
  }

  function renderGroupReporting(
    groupReporting: any,
    prfNumber: string
  ): string {
    console.log('groupReporting in PDF Utility:', groupReporting);
    if (!groupReporting.isGroupReporting) {
      return `<em>Group Reporting is disabled for ${prfNumber}</em>`;
    }
    return `
    <table border="1" cellpadding="4" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:13px;margin-bottom:16px;">
      <thead style="background:#f5f5f5;">
        <tr>
          <th>#</th>
          <th>PDB Number</th>
          <th>Company</th>
          <th>NAIC</th>
          <th>AMBest</th>
        </tr>
      </thead>
      <tbody>
        ${groupReporting.includedList
          .map(
            (item: any, i: number) => `
          <tr>
            <td>${i + 1}</td>
            <td>${item.No || ''}</td>
            <td>${item.Name || ''}</td>
            <td>${item.NAIC || '-'}</td>
            <td>${item.AMBest || '-'}</td>
          </tr>
        `
          )
          .join('')}
      </tbody>
    </table>
    `;
  }

  function renderAnnualStatement(
    annualStatement: any,
    isoline?: string
  ): string {
    if (
      !annualStatement ||
      !Array.isArray(annualStatement) ||
      annualStatement.length === 0
    ) {
      return '<em>No Data</em>';
    }
    return `
    <table border="1" cellpadding="4" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:13px;margin-bottom:16px;">
      <thead style="background:#f5f5f5;">
        <tr>
          <th></th>
          <th>Category</th>
          <th>Direct</th>
          <th>Reinsurance From Non-Affiliates</th>
        </tr>
      </thead>
      <tbody>
        ${annualStatement
          .map((item: any) => {
            if (item.Text?.toLowerCase().includes('aggregate write-in')) {
              return `
              <tr>
                <td>${item.DisplayText || ''}</td>
                <td>ISO Line To Apply Aggregate Write-In</td>
                <td>${isoline || '-'}</td>
                <td></td>
              </tr>
            `;
            } else {
              return `
              <tr>
                <td>${item.DisplayText || ''}</td>
                <td>${item.Text || ''}</td>
                <td>${item.Col1 !== undefined ? item.Col1 : ''}</td>
                <td>${item.Col2 !== undefined ? item.Col2 : ''}</td>
              </tr>
            `;
            }
          })
          .join('')}
      </tbody>
    </table>
    `;
  }

  function renderValidationSummary(validationSummary: any[]): string {
    if (
      !validationSummary ||
      !Array.isArray(validationSummary) ||
      validationSummary.length === 0
    ) {
      return '<em>No Data</em>';
    }
    function getStatusText(item: any): string {
      if (item.isInFeedbackUpdatedState) return 'Feedback Updated';
      return item.status === 'OK' ? 'Successful' : 'Warning';
    }
    function getStatusIcon(item: any): string {
      if (item.isInFeedbackUpdatedState) {
        return `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#000000" style="vertical-align:middle;margin-right:6px;"><path d="M480-120q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-480q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q82 0 155.5 35T760-706v-94h80v240H600v-80h110q-41 56-101-88t-129-32q-117 0-198.5 81.5T200-480q0 117 81.5 198.5T480-200q105 0 183.5-68T756-440h82q-15 137-117.5 228.5T480-120Zm112-192L440-464v-216h80v184l128 128-56 56Z"/></svg>`;
      }
      if (item.status === 'OK') {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" style="vertical-align:middle;margin-right:6px;"><path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#009D4F"/></svg>`;
      }
      return `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="#f4af2d" style="vertical-align:middle;margin-right:6px;"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>`;
    }
    return `
    <table border="1" cellpadding="4" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:13px;">
      <thead style="background:#f5f5f5;">
        <tr>
          <th>Status</th>
          <th>Rule</th>
        </tr>
      </thead>
      <tbody>
        ${validationSummary
          .map(
            (item: any) => `
          <tr>
            <td>
              ${getStatusIcon(item)}
              ${getStatusText(item)}
            </td>
            <td>${item.ruleName || ''}</td>
          </tr>
        `
          )
          .join('')}
      </tbody>
    </table>
    `;
  }

  function renderComments(comments: any): string {
    if (!comments) {
      return `<p class="no-comments-container" style="padding: 12px 0; color: #888; font-style: italic;">No comments added.</p>`;
    }
    return `
      <div class="comments-container" style="
        margin-bottom:16px;
        width: 100%;
        min-height: 120px;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 8px;
        font-size: 13px;
        background: #f9f9f9;
        color: #222;
        box-sizing: border-box;
        white-space: pre-wrap;
        word-break: break-word;
      ">${comments}
      </div>
    `;
  }

  function renderPremiumSummary(premiumDetails: any): string {
    if (!premiumDetails) {
      return `<em>No Data</em>`;
    }
    const d = Array.isArray(premiumDetails)
      ? premiumDetails[0]
      : premiumDetails;
    if (!d) return `<em>No Data</em>`;
    function fmt(val: any) {
      if (val === undefined || val === null || isNaN(val)) return '—';
      return Number(val).toLocaleString('en-US', { maximumFractionDigits: 0 });
    }
    return `
    <div style="margin-bottom:16px;">
      <table border="1" cellpadding="4" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:13px;">
        <thead style="background:#f5f5f5;">
          <tr>
            <th style="text-align:left;"><strong>Premium</strong></th>
            <th style="text-align:left;"><strong>Value</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${Labels.premium.direct}</td>
            <td>${fmt(d.direct_premium)}</td>
          </tr>
          <tr>
            <td>${Labels.premium.supplemental}</td>
            <td>${fmt(d.supplemental_premium)}</td>
          </tr>
          <tr>
            <td>${Labels.premium.userDefinedDirect}</td>
            <td>${fmt(d.userdefined_premium)}</td>
          </tr>
          <tr>
            <td>${Labels.premium.userDefinedSupplemental}</td>
            <td>${fmt(d.userdefined_premium_supplemental)}</td>
          </tr>
          <tr>
            <td style="font-weight:600;">Total Premium</td>
            <td style="font-weight:600;">${fmt(d.total_premium)}</td>
          </tr>
        </tbody>
      </table>
    </div>
    `;
  }

  function renderUserDefinedDataSummary(premiumDetails: any): string {
    if (!premiumDetails) {
      return `<em>No Data</em>`;
    }
    const d = Array.isArray(premiumDetails)
      ? premiumDetails[0]
      : premiumDetails;
    if (!d) return `<em>No Data</em>`;
    function fmt(val: any) {
      if (val === undefined || val === null || isNaN(val)) return '—';
      return Number(val).toLocaleString('en-US', { maximumFractionDigits: 0 });
    }
    return `
    <div style="margin-bottom:16px;">
     <div style="font-weight:600;margin-bottom:8px;">
        Premium Details</div>
      <table border="1" cellpadding="4" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:13px;">
        <thead style="background:#f5f5f5;">
          <tr>
            <th style="text-align:left;"><strong>Premium</strong></th>
            <th style="text-align:left;"><strong>Value</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${Labels.premium.userDefinedDirect}</td>
            <td>${fmt(d.userdefined_premium)}</td>
          </tr>
          <tr>
            <td>${Labels.premium.userDefinedSupplemental}</td>
            <td>${fmt(d.userdefined_premium_supplemental)}</td>
          </tr>
          <tr>
            <td style="font-weight:600;">Total Premium</td>
            <td style="font-weight:600;">${fmt(
              d.userdefined_premium + d.userdefined_premium_supplemental
            )}</td>
          </tr>
        </tbody>
      </table>
    </div>
    `;
  }

  function renderUserDefinedColumns(userDefinedCols: any): string {
    if (
      !userDefinedCols ||
      !Array.isArray(userDefinedCols) ||
      userDefinedCols.length === 0
    ) {
      return '<p style="font-style:italic;color:#666;margin-bottom:16px;">No custom columns added.</p>';
    }
    return `
    <div style="font-weight:600;margin-bottom:10px;">
        Details of custom columns added</div>
      <table border="1" cellpadding="6" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:13px;margin-bottom:16px;">
        <thead style="background:#f5f5f5;">
          <tr>
            <th style="width:40px;">#</th>
            <th style="text-align:left;">Column Name</th>
            <th style="text-align:left;">ISO Program</th>
            <th style="text-align:left;">ISO Matching Column</th>
          </tr>
        </thead>
        <tbody>
          ${userDefinedCols
            .map(
              (item: any, i: number) => `
              <tr>
                <td style="text-align:center;">${i + 1}</td>
                <td>${item.ColName || ''}</td>
                <td>${item.ISOCol === 'on' ? 'Yes' : 'No'}</td>
                <td>${item.MatchCol || ''}</td>
              </tr>
            `
            )
            .join('')}
        </tbody>
      </table>
    `;
  }
  function createTempContainer(): HTMLDivElement {
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'fixed';
    tempContainer.style.left = '-9999px';
    tempContainer.style.top = '0';
    tempContainer.style.width = '900px';
    tempContainer.style.pointerEvents = 'none';
    tempContainer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(tempContainer);
    return tempContainer;
  }

  async function renderSectionToCanvas(
    sectionHtml: string,
    tempContainer: HTMLDivElement,
    scaleOverride?: number
  ): Promise<HTMLCanvasElement> {
    tempContainer.innerHTML = sectionHtml;

    const scale = 1.2;
    const canvas = await html2canvas(tempContainer, {
      scale: scaleOverride ?? scale,
      useCORS: false,
      allowTaint: false,
      backgroundColor: '#ffffff',
      logging: false,
    });
    // clear container for next render
    tempContainer.innerHTML = '';
    return canvas;
  }

  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: 'a4',
  });

  // Add canvas to PDF, splitting into multiple pages if the rendered image is taller than a PDF page.
  function addCanvasPagesToPdf(
    canvas: HTMLCanvasElement,
    pdfInstance: jsPDF,
    isFirstPage: boolean
  ) {
    const pageWidth = pdfInstance.internal.pageSize.getWidth();
    const pageHeight = pdfInstance.internal.pageSize.getHeight();

    // Compute how many canvas pixels correspond to one PDF page height
    const sliceHeightCanvas = Math.floor(
      (pageHeight * canvas.width) / pageWidth
    );
    let y = 0;
    let pageIndex = 0;

    while (y < canvas.height) {
      const h = Math.min(sliceHeightCanvas, canvas.height - y);
      // create a temporary canvas for the slice
      const sliceCanvas = document.createElement('canvas');
      sliceCanvas.width = canvas.width;
      sliceCanvas.height = h;
      const ctx = sliceCanvas.getContext('2d');
      // draw the slice from original canvas
      ctx.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h);

      const imgData = sliceCanvas.toDataURL('image/jpeg', 0.75);

      if (!(isFirstPage && pageIndex === 0)) {
        pdfInstance.addPage();
      }

      // draw slice scaled to page width & height (height may be less than pageHeight for last slice)
      const imgHeightPdf = (h * pageWidth) / canvas.width;
      pdfInstance.addImage(imgData, 'JPEG', 0, 0, pageWidth, imgHeightPdf);
      sliceCanvas.width = 0;
      sliceCanvas.height = 0;
      // move to next slice
      y += h;
      pageIndex++;
    }
  }

  const sections = [
    {
      title: 'Company Information',
      content: renderCompanyInfo(results.companyInfo),
    },
    {
      title: 'Group Reporting',
      content: renderGroupReporting(results.groupReporting, prfNumber),
    },
    {
      title: 'Annual Statement',
      content: renderAnnualStatement(
        results.annualStatement,
        results.selectedIsoLines
      ),
    },
    {
      title: 'Premium Report',
      content: renderPremiumSummary(results.premiumDetails),
    },
    {
      title: 'User Defined Data',
      // combine details of custom columns and the user defined premium summary so they render together
      content:
        renderUserDefinedColumns(results.userDefinedCols) +
        renderUserDefinedDataSummary(results.premiumDetails),
    },
    {
      title: 'Comments',
      content: renderComments(results.comments),
    },
    {
      title: 'Validation Summary',
      content: renderValidationSummary(results.validationSummary),
    },
  ];

  // Process sequentially to reduce concurrent memory usage
  const tempContainer = createTempContainer();
  let isFirstPage = true;
  const filename =
    options?.filename ||
    `Submission Summary Report_${prfNumber}_${currentYear}.pdf`;
  try {
    const PAGE_WIDTH = 900;
    const PAGE_HEIGHT = Math.floor(PAGE_WIDTH * 1.414);

    const fullHtml = sections
      .map(
        (section, i) => `
  <div style="
    width:${PAGE_WIDTH}px;
    height:${PAGE_HEIGHT}px;
    padding:32px;
    box-sizing:border-box;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    page-break-after:always;
    break-after:page;
    background:#ffffff;
  ">
    <h1 style="text-align:center;color:#00358e;font-size:32px;margin:0;">
      Summary Report : ${currentYear}
    </h1>

    <h3 style="text-align:center;font-size:22px;margin:8px 0 16px;">
      ${prfNumber} : ${prfName}
    </h3>

    <h2 style="font-size:20px;margin-bottom:12px;">
      ${i + 1}. ${section.title}
    </h2>

    <div style="flex:1; overflow:hidden;">
      ${section.content}
    </div>
  </div>
`
      )
      .join('');

    // 2. Render ONCE
    const canvas = await renderSectionToCanvas(
      fullHtml,
      tempContainer,
      options?.scale ?? 1.2
    );

    // 3. Add pages from this one canvas
    addCanvasPagesToPdf(canvas, pdf, true);

    canvas.width = 0;
    canvas.height = 0;

    function addFootersToPdf(pdfInstance: jsPDF, year: number) {
      try {
        let internalPagesCount = 1;
        if (pdfInstance.internal?.pages) {
          internalPagesCount = pdfInstance.internal.pages.length - 1;
        }
        const pageCount =
          typeof pdfInstance.getNumberOfPages === 'function'
            ? pdfInstance.getNumberOfPages()
            : internalPagesCount;

        const pageWidth = pdfInstance.internal.pageSize.getWidth();
        const pageHeight = pdfInstance.internal.pageSize.getHeight();
        const margin = 12;
        const y = pageHeight - 12;
        const timestamp = new Date().toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        });

        pdfInstance.setFontSize(10);
        const getTextWidth = (text: string) => {
          if (typeof pdfInstance.getTextWidth === 'function') {
            return Math.ceil(pdfInstance.getTextWidth(text));
          }
          const fontSize =
            typeof pdfInstance.getFontSize === 'function'
              ? pdfInstance.getFontSize()
              : 10;
          return Math.ceil(text.length * fontSize * 0.5);
        };

        const truncateToWidth = (fullText: string, maxWidth: number) => {
          if (maxWidth <= 0) return '';
          if (getTextWidth(fullText) <= maxWidth) return fullText;
          const ell = '…';
          let left = 0;
          let right = fullText.length;
          while (left < right) {
            const mid = Math.ceil((left + right) / 2);
            const candidate = fullText.slice(0, mid) + ell;
            if (getTextWidth(candidate) <= maxWidth) {
              left = mid;
            } else {
              right = mid - 1;
            }
          }
          return fullText.slice(0, left) + ell;
        };

        const smallGap = 8;

        for (let p = 1; p <= pageCount; p++) {
          pdfInstance.setPage(p);

          const pageText = `Page ${p} of ${pageCount}`;

          const leftWidth = getTextWidth(timestamp);
          const pageTextWidth = getTextWidth(pageText);
          var today = new Date();
          const copyrightFull = `Copyright © ${today.getFullYear()} Insurance Services Office, Inc. All rights reserved.`;
          let copyrightFinal = copyrightFull;
          let copyrightWidth = getTextWidth(copyrightFinal);

          // compute occupied edges
          let leftEnd = margin + leftWidth + smallGap;
          let rightStart = pageWidth - margin - copyrightWidth - smallGap;

          // if not enough space for the page text, truncate copyright to make room
          if (rightStart - leftEnd < pageTextWidth) {
            const maxCopyrightWidth = Math.max(
              0,
              pageWidth - leftWidth - pageTextWidth - margin * 4
            );
            copyrightFinal = truncateToWidth(copyrightFull, maxCopyrightWidth);
            copyrightWidth = getTextWidth(copyrightFinal);
            rightStart = pageWidth - margin - copyrightWidth - smallGap;
            leftEnd = margin + leftWidth + smallGap;
          }

          // determine center X for page text inside remaining region; fallback to page center
          let middleX: number;
          if (rightStart > leftEnd) {
            middleX = (leftEnd + rightStart) / 2;
          } else {
            middleX = pageWidth / 2;
          }

          // render footer pieces
          pdfInstance.text(timestamp, margin, y, { align: 'left' as any });
          pdfInstance.text(pageText, middleX, y, { align: 'center' as any });
          pdfInstance.text(copyrightFinal, pageWidth - margin, y, {
            align: 'right' as any,
          });
        }
      } catch (err) {
        console.error('Failed to add footers to PDF', err);
      }
    }

    // call footer helper before saving
    addFootersToPdf(pdf, currentYear);

    pdf.save(filename);
  } catch (err) {
    console.error('Failed to generate PDF', err);
    throw err;
  } finally {
    // cleanup temp container
    if (tempContainer.parentNode)
      tempContainer.parentNode.removeChild(tempContainer);
  }
};
